import {useState} from 'react';

import {useAppSelector} from 'hooks';
import {isSyncBasketEnabled} from 'utils/helper';

import {BasketWeightCapacityComponent} from './BasketWeightCapacity.component';
import {ExpressWeightCapacityModal} from './ExpressWeightCapacityModal';
import {StickyContainerWrapper} from './styles';

export const BasketWeightCapacityStickyComponent = () => {
  const [openBasketCapacityModal, setOpenBasketCapacityModal] = useState(false);
  const storeSelecteditems = useAppSelector((state) => state?.basket?.selectedItems);
  const localeSelectedItems = JSON.parse(localStorage.getItem('selectedItems') || '[]') || [];
  const isSyncBasket = isSyncBasketEnabled();
  const selectedItems = isSyncBasket ? storeSelecteditems : localeSelectedItems;
  const toggleModal = () => {
    setOpenBasketCapacityModal((prev) => !prev);
  };
  if (!selectedItems?.length) {
    return null;
  }
  return (
    <StickyContainerWrapper>
      <BasketWeightCapacityComponent onClick={toggleModal} />
      <ExpressWeightCapacityModal open={openBasketCapacityModal} onClose={toggleModal} />
    </StickyContainerWrapper>
  );
};
